import { createContext } from "react";

const MyContext = createContext();
MyContext.displayName = "CalendarContext";

export default MyContext;
